export const Header = [2095, 637, 2102];
export const Footer = [];

export { ReactComponent as AddTag } from './images/AddTag.svg';
export { ReactComponent as HandImg } from './images/handImg.svg';
export { ReactComponent as Elipred } from './images/elipred.svg';
export { ReactComponent as ROEmpty } from './images/roempty.svg';
export { ReactComponent as TrashIcon } from './images/Trash.svg';
export { ReactComponent as InputOk } from './images/inputOk.svg';
export { ReactComponent as CarIcon } from './images/carIcon.svg';
export { ReactComponent as JcbCard } from './images/jcbcard.svg';
export { ReactComponent as CardPay } from './images/cardpay.svg';
export { ReactComponent as CashPay } from './images/cashpay.svg';
export { ReactComponent as VisaCard } from './images/visacard.svg';
export { ReactComponent as InfoIcon } from './images/infoIcon.svg';
export { ReactComponent as LockIcon } from './images/Lock.svg';
export { ReactComponent as LockOpenIcon } from './images/LockOpenIcon.svg';
export { ReactComponent as HandIcon } from './images/handIcon.svg';
export { ReactComponent as CloseTag } from './images/closeTag.svg';
export { ReactComponent as PopClose } from './images/PopClose.svg';
export { ReactComponent as TimeIcon } from './images/TimeIcon.svg';
export { ReactComponent as FileIcon } from './images/fileIcon.svg';
export { ReactComponent as AmexCard } from './images/amexcard.svg';
export { ReactComponent as PlayIcon } from './images/playIcon.svg';
export { ReactComponent as ChatIcon } from './images/ChatIcon.svg';
export { ReactComponent as Nexpart } from './images/NexparIcon.svg';
export { ReactComponent as SigninImg } from './images/SigninImg.svg';
export { ReactComponent as DarkLogo } from './images/FooterLogo.svg';
export { ReactComponent as PauseIcon } from './images/pauseIcon.svg';
export { ReactComponent as ListDelIcon } from './images/listdel.svg';
export { ReactComponent as EyeIcon } from './images/EyeViewIcon.svg';
export { ReactComponent as WhiteLogo } from './images/WhiteLogo.svg';
export { ReactComponent as NavToggle } from './images/navtoggle.svg';
export { ReactComponent as EngineImg } from './images/engineImg.svg';
export { ReactComponent as ElipGreen } from './images/elipgreen.svg';
export { ReactComponent as ArrowLeft } from './images/ArrowLeft.svg';
export { ReactComponent as ThreeBars } from './images/threebars.svg';
export { ReactComponent as InfoOhoIcon } from './images/infoOho.svg';
export { ReactComponent as LeftArrow } from './images/LeftArrow.svg';
export { ReactComponent as CommuChat } from './images/CommuChat.svg';
export { ReactComponent as NexpartMain } from './images/Nexpart.svg';
export { ReactComponent as Purchases } from './images/Purchases.svg';
export { ReactComponent as ShareIcon } from './images/shareIcon.svg';
export { ReactComponent as PaypalPay } from './images/paypalpay.svg';
export { ReactComponent as ChequePay } from './images/checquepay.svg';
export { ReactComponent as SendGridIcon } from './images/SendGrid.svg';
export { ReactComponent as WalletCard } from './images/walletcard.svg';
export { ReactComponent as EngineIcon } from './images/engineIcon.svg';
export { ReactComponent as DatabaceIcon } from './images/database.svg';
export { ReactComponent as AddItemsIcon } from './images/addItems.svg';
export { ReactComponent as GasolineIcon } from './images/gasoline.svg';
export { ReactComponent as ElipOrange } from './images/eliporange.svg';
export { ReactComponent as JobBoardIcon } from './images/jobboard.svg';
export { ReactComponent as AddSideBar } from './images/addSidebar.svg';
export { ReactComponent as CrossError } from './images/CrossError.svg';
export { ReactComponent as ListEditIcon } from './images/listedit.svg';
export { ReactComponent as PaymentReq } from './images/paymentreq.svg';
export { ReactComponent as MasterCard } from './images/mastercard.svg';
export { ReactComponent as LogoutIcon } from './images/logoutIcon.svg';
export { ReactComponent as ListingDot } from './images/listingDot.svg';
export { ReactComponent as SearchIcon } from './images/searchIcon.svg';
export { ReactComponent as ReportIcon } from './images/ReportIcon.svg';
export { ReactComponent as ExportIcon } from './images/exportIcon.svg';
export { ReactComponent as TwilioIcon } from './images/TwilioIcon.svg';
export { ReactComponent as FooterLogo } from './images/FooterLogo.svg';
export { ReactComponent as PasswordShow } from './images/PassShow.svg';
export { ReactComponent as PasswordHide } from './images/PassHide.svg';
export { ReactComponent as SigninUser } from './images/Signupuser.svg';
export { ReactComponent as RightArrow } from './images/ArrowRight.svg';
export { ReactComponent as CommuEmail } from './images/CommuEmail.svg';
export { ReactComponent as ListCarrot } from './images/listCarrot.svg';
export { ReactComponent as SmallShops } from './images/smallShops.svg';
export { ReactComponent as GreenCheck } from './images/greenCheck.svg';
export { ReactComponent as AddIconBg } from './images/addlightbgsm.svg';
export { ReactComponent as RemoveIconP } from './images/removeicon.svg';
export { ReactComponent as ListResetIcon } from './images/ListReset.svg';
export { ReactComponent as EstimateAdd } from './images/estimateadd.svg';
export { ReactComponent as EditSideBar } from './images/editSidebar.svg';
export { ReactComponent as NewFieldAdd } from './images/newFieldAdd.svg';
export { ReactComponent as CustomerCar } from './images/customerCar.svg';
export { ReactComponent as AddNewField } from './images/addNewField.svg';
export { ReactComponent as WeatherIcon } from './images/Weathericon.svg';
export { ReactComponent as TorquePayIcon } from './images/torquepay.svg';
export { ReactComponent as SuccessTick } from './images/successtick.svg';
export { ReactComponent as TimeClockIcon } from './images/timeclock.svg';
export { ReactComponent as TorqueLogoOpen } from './images/logoopen.svg';
export { ReactComponent as RefreshIcon } from './images/refreshicon.svg';
export { ReactComponent as MinimizeJob } from './images/MinimizeJob.svg';
export { ReactComponent as GoogleIcon } from './images/googleSignup.svg';
export { ReactComponent as EmailIconCV } from './images/emailIconCV.svg';
export { ReactComponent as BoardCar } from './images/NewJobBoardCar.svg';
export { ReactComponent as ListChecked } from './images/listChecked.svg';
export { ReactComponent as BoardSWV } from './images/NewJobBoardSWV.svg';
export { ReactComponent as SigninEmail } from './images/Signupemail.svg';
export { ReactComponent as NoDataFound } from './images/NoDateFound.svg';
export { ReactComponent as SettingIcon } from './images/settingIcon.svg';
export { ReactComponent as MotorDriven } from './images/MOTORDriven.svg';
export { ReactComponent as SignOutIcon } from './images/signoutIcon.svg';
export { ReactComponent as BigPlayIcon } from './images/BigPlayIcon.svg';
export { ReactComponent as CustomerMsgIcon } from './images/CustomerMsg.svg';
export { ReactComponent as PhoneIconCV } from './images/mobileIconCV.svg';
export { ReactComponent as ArrowRight } from './images/ArrowPrevious.svg';
export { ReactComponent as LeadFormImg } from './images/LeadFormImg1.svg';
export { ReactComponent as AddIconList } from './images/addiconlists.svg';
export { ReactComponent as GasolineImg } from './images/gasolineMask.svg';
export { ReactComponent as QuickbooksIcon } from './images/Quickbooks.svg';
export { ReactComponent as DiscoverCard } from './images/discovercard.svg';
export { ReactComponent as RevenueEmpty } from './images/revenueEmpty.svg';
export { ReactComponent as InvoiceEmpty } from './images/invoiceEmpty.svg';
export { ReactComponent as TechnicanImg } from './images/technicanImg.svg';
export { ReactComponent as DownloadIcon } from './images/downloadIcon.svg';
export { ReactComponent as MoreVertIcon } from './images/MoreVertIcon.svg';
export { ReactComponent as CustomerIcon } from './images/customerIcon.svg';
export { ReactComponent as SubmitSignIn } from './images/SubmitSignup.svg';
export { ReactComponent as GoogleSignup } from './images/googleSignup.svg';
export { ReactComponent as EyeIconBorderless } from './images/eyeIcon.svg';
export { ReactComponent as BoardJobs } from './images/NewJobBoardJobs.svg';
export { ReactComponent as FavListEmpty } from './images/FavListEmpty.svg';
export { ReactComponent as CommuComment } from './images/CommuComment.svg';
export { ReactComponent as BoardChat } from './images/NewJobBoardChat.svg';
export { ReactComponent as BoardTime } from './images/NewJobBoardTime.svg';
export { ReactComponent as BoardCash } from './images/NewJobBoardCash.svg';
export { ReactComponent as TorqueGrowth } from './images/TorqueGrowth.svg';
export { ReactComponent as GreenVectorIcon } from './images/greenIcon.svg';
export { ReactComponent as TutorialIcon } from './images/TutorialIcon.svg';
export { ReactComponent as LabelAddImage } from './images/uploadimage.svg';
export { ReactComponent as OverPhonePay } from './images/overPhonePay.svg';
export { ReactComponent as UnionPayCard } from './images/unionpaycard.svg';
export { ReactComponent as ViewListIcon } from './images/viewListIcon.svg';
export { ReactComponent as ImportIconLg } from './images/ImportIconLg.svg';
export { ReactComponent as CrossIcon } from './images/crossInspection.svg';
export { ReactComponent as OpenListIcon } from './images/openlisticon.svg';
export { ReactComponent as JobBoardTime } from './images/jobboardtime.svg';
export { ReactComponent as MailOpenIcon } from './images/MailOpenIcon.svg';
export { ReactComponent as BusinessPlan } from './images/busuinessPlan.svg';
export { ReactComponent as ListingActive } from './images/listinActive.svg';
export { ReactComponent as ImportIcon } from './images/importiconsmall.svg';
export { ReactComponent as AddIcon } from './images/inspectioncustomer.svg';
export { ReactComponent as ListUnchecked } from './images/listUnchecked.svg';
export { ReactComponent as UniversalIcon } from './images/universalIcon.svg';
export { ReactComponent as WiringDiagram } from './images/wiringDiagram.svg';
export { ReactComponent as PartCatalog } from './images/partCatalogIcon.svg';
export { ReactComponent as SuccessTickSM } from './images/successTickSm.svg';
export { ReactComponent as FacebookIcon } from './images/facebookSignup.svg';
export { ReactComponent as SmallShopsPkg } from './images/smallShopsPkg.svg';
export { ReactComponent as BoardClock } from './images/NewJobBaordClock.svg';
export { ReactComponent as UploadIcon } from './images/uploadVehicleImg.svg';
export { ReactComponent as JobCardChat } from './images/jobcardchaticon.svg';
export { ReactComponent as PricingListIcon } from './images/pricinglist.svg';
export { ReactComponent as TechnicanIcon } from './images/technicanIcon.svg';
export { ReactComponent as GreenCameraIcon } from './images/greencamera.svg';
export { ReactComponent as ElipFilledRed } from './images/elipfilledred.svg';
export { ReactComponent as RevenueLoader } from './images/revenueLoader.svg';
export { ReactComponent as TorqueDigital } from './images/TorqueDigital.svg';
export { ReactComponent as SelectBoxIcon } from './images/SelectboxIcon.svg';
export { ReactComponent as UploadFile } from './images/uploadVehicleImg.svg';
export { ReactComponent as CloseSidebar } from './images/closenavsidebar.svg';
export { ReactComponent as RemoveIconBg } from './images/removelightbgsm.svg';
export { ReactComponent as BadgeButton } from './images/addmechanicbadge.svg';
export { ReactComponent as CrossIconList } from './images/crossticklists.svg';
export { ReactComponent as ReviewCampaign } from './images/ReviewCampaign.svg';
export { ReactComponent as DashboardIcon1 } from './images/DashboardIcon1.svg';
export { ReactComponent as UploadFileLogo } from './images/UploadFileLogo.svg';
export { ReactComponent as DashboardIcon2 } from './images/DashboardIcon2.svg';
export { ReactComponent as DashboardIcon3 } from './images/DashboardIcon3.svg';
export { ReactComponent as DashboardIcon4 } from './images/DashboardIcon4.svg';
export { ReactComponent as DashboardIcon5 } from './images/DashboardIcon5.svg';
export { ReactComponent as DashboardIcon6 } from './images/DashboardIcon6.svg';
export { ReactComponent as FacebookSignup } from './images/facebookSignup.svg';
export { ReactComponent as AddNewActivity } from './images/addnewActivity.svg';
export { ReactComponent as SigninPassword } from './images/SignupPassword.svg';
export { ReactComponent as SettingSidebar } from './images/sidebarsetting.svg';
export { ReactComponent as WalkinCustomer } from './images/WalkinCustomer.svg';
export { ReactComponent as NotificationIcon } from './images/notification.svg';
export { ReactComponent as JobBoardFilled } from './images/jobBoardFilled.svg';
export { ReactComponent as SettingsActive } from './images/settingsActive.svg';
export { ReactComponent as AddInvoiceIcon } from './images/addiconinvoice.svg';
export { ReactComponent as ROJobcardEmpty } from './images/rojobcardEmpty.svg';
export { ReactComponent as ROInvoiceEmpty } from './images/roInvoiceEmpty.svg';
export { ReactComponent as VINPlaceholder } from './images/vinplaceholder.svg';
export { ReactComponent as FileAttachment } from './images/fileAttechment.svg';
export { ReactComponent as MailClicksIcon } from './images/MailClicksIcon.svg';
export { ReactComponent as NewTemplateAdd } from './images/newTemplateAdd.svg';
export { ReactComponent as CameraUploadIcon } from './images/cameraupload.svg';
export { ReactComponent as CrossSmallError } from './images/corssSmallicon.svg';
export { ReactComponent as ReportsFilled } from './images/ReportsFilledIcon.svg';
export { ReactComponent as AddReplacedIcon } from './images/addEstimateCard.svg';
export { ReactComponent as MasterCardWhite } from './images/mastercardwhite.svg';
export { ReactComponent as SuccessIconList } from './images/succssticklists.svg';
export { ReactComponent as ServiceReminder } from './images/ServiceReminder.svg';
export { ReactComponent as AppointmentIcon } from './images/AppointmentIcon.svg';
export { ReactComponent as RoEstimateEmpty } from './images/roEstimateEmpty.svg';
export { ReactComponent as SearchRoundIcon } from './images/searchRoundIcon.svg';
export { ReactComponent as PurchasesActive } from './images/PurchasesActive.svg';
export { ReactComponent as TorqueGrowthPkg } from './images/torqueGrowthPkg.svg';
export { ReactComponent as BoardTech } from './images/NewJobBoardTechnician.svg';
export { ReactComponent as VideoPausedIcon } from './images/videoPausedIcon.svg';
export { ReactComponent as VideoPlayedIcon } from './images/videoPlayedIcon.svg';
export { ReactComponent as AppointmentMore } from './images/AppointmentMore.svg';
export { ReactComponent as ElipFilledGreen } from './images/elipfilledgreen.svg';
export { ReactComponent as JobBoardComment } from './images/jobboardcomment.svg';
export { ReactComponent as CalendarEmpty } from './images/calendarEmptyState.svg';
export { ReactComponent as VideoCompleteIcon } from './images/videoEndedIcon.svg';
export { ReactComponent as DashboardInactive } from './images/dashboardEmpty.svg';
export { ReactComponent as ServiceHistory } from './images/inspectionservice.svg';
export { ReactComponent as DatePicker } from './images/appointmentdatepicker.svg';
export { ReactComponent as TimePicker } from './images/apooitnmenttimepicker.svg';
export { ReactComponent as ElipFilledOrange } from './images/elipfilledorange.svg';
export { ReactComponent as NewEntryNoti } from './images/Dashboardnewentrybtn.svg';
export { ReactComponent as SavePreview } from './images/saveinspectionpreview.svg';
export { ReactComponent as EditReplacedIcon } from './images/editEstimateCard.svg';
export { ReactComponent as SendPreview } from './images/sendinspectionpreview.svg';
export { ReactComponent as MinusInvoiceIcon } from './images/minusiconinvoice.svg';
export { ReactComponent as BoardListView } from './images/NewJobBoardListView.svg';
export { ReactComponent as BoardTagView } from './images/NewJobBoardTagView.svg';
export { ReactComponent as BoardStageView } from './images/NewJobBoardStageView.svg';
export { ReactComponent as BoardCardView } from './images/NewJobBoardCardView.svg';
export { ReactComponent as BusinessPlusIcon } from './images/BusinessPlusIcon.svg';
export { ReactComponent as PlusIcon } from './images/PlusIcon.svg';
export { ReactComponent as BoardCalendar } from './images/NewJobBoardCalendar.svg';
export { ReactComponent as BoardCustomer } from './images/NewJobBoardCustomer.svg';
export { ReactComponent as EmailSharingIcon } from './images/EmailSharingIcon.svg';
export { ReactComponent as JobCardMessage } from './images/jobcardmessageicon.svg';
export { ReactComponent as TorquePayIconWhite } from './images/TorquePayWhite.svg';
export { ReactComponent as SharePreview } from './images/shareinpectionprevie.svg';
export { ReactComponent as InspectionAdd } from './images/addinspectionplusbtn.svg';
export { ReactComponent as AppointmentFilled } from './images/AppointmentFilled.svg';
export { ReactComponent as AdsonSubscription } from './images/AdsonSubscription.svg';
export { ReactComponent as SearchfilterIcon } from './images/searchfilterSmIcon.svg';
export { ReactComponent as ROInspectionEmpty } from './images/roInspectionEmpty.svg';
export { ReactComponent as CommunicationMail } from './images/communicationmail.svg';
export { ReactComponent as PrintPreview } from './images/printinspectionpreview.svg';
export { ReactComponent as NoEmailConnection } from './images/NoEmailConnection.svg';
export { ReactComponent as EstimateChecked } from './images/estimatecheckedradio.svg';
export { ReactComponent as EditProfileSettings } from './images/EditsettingsIcon.svg';
export { ReactComponent as AddSearchImage } from './images/searchresultImageIcon.svg';
export { ReactComponent as BoardFileAttach } from './images/NewJobBoardFileAttach.svg';
export { ReactComponent as NewTemplateGroupUp } from './images/newtemplategroupup.svg';
export { ReactComponent as InspectionCustomer } from './images/inspectioncustomer.svg';
export { ReactComponent as EstimateSearchTick } from './images/estimatesearchtick.svg';
export { ReactComponent as DigiInspectionIcon } from './images/DigiInspectionIcon.svg';
export { ReactComponent as ROAppointmentEmpty } from './images/roAppointmentEmpty.svg';
export { ReactComponent as DashboardTickIcon } from './images/DashboardStatusTick.svg';
export { ReactComponent as CampaignerEmpty } from './images/CampaignerEmptyScreen.svg';
export { ReactComponent as DelIconWitoutBorder } from './images/DelIconWitoutBorder.svg';
export { ReactComponent as UpgradeSubscription } from './images/upgradeSubscription.svg';
export { ReactComponent as AutoCompleteIcon } from './images/appointmentautocomplete.svg';
export { ReactComponent as EstimateUnchecked } from './images/estimateuncheckedradio.svg';
export { ReactComponent as CommuMediaAttachment } from './images/CommuMediaAttachment.svg';
export { ReactComponent as CommunicationMessage } from './images/communicationmessage.svg';
export { ReactComponent as VehiclePlaceholder } from './images/vehicleIconPlaceholder.svg';
export { ReactComponent as CustomerPlaceholder } from './images/cutomerIconPlaceholder.svg';
export { ReactComponent as AppointmentCornerIcon } from './images/appointmentCornerIcon.svg';
export { ReactComponent as SettingSubscriedIcon } from './images/settingSubscribedprice.svg';
export { ReactComponent as CustomerAddAppointment } from './images/customerAddAppointment.svg';
export { ReactComponent as CheckedIconCancellation } from './images/checkedIconCancellation.svg';
export { ReactComponent as UncheckedIconCancellation } from './images/uncheckediconcancellation.svg';
export { ReactComponent as CheckedCampaignerIcon } from './images/checkedCampaigner.svg';
export { ReactComponent as UncheckedCampaignerIcon } from './images/unCheckedCampaigner.svg';
export { ReactComponent as QtyMinusIcon } from './images/QtyMinusIcon.svg';
export { ReactComponent as QtyPlusIcon } from './images/QtyPlusIcon.svg';
export { ReactComponent as PartsTechMain } from './images/techParts.svg';
export { ReactComponent as CarfaxHistory } from './images/serviceIcon.svg';
export { ReactComponent as RepairOrder } from './images/RepairOrder.svg';
export { ReactComponent as DiscountCampaign } from './images/DiscountCampaign.svg';
export { ReactComponent as AppointmentReminderCampaign } from './images/AppointmentCampaign.svg';
export { ReactComponent as SoldItemCampaign } from './images/SoldItemCampaign.svg';
export { ReactComponent as Person } from './images/Person.svg';
export { ReactComponent as BrevoIcon } from './images/Brevo.svg';
export { ReactComponent as ChatsTeardropIcon } from './images/ChatsTeardropIcon.svg';
export { ReactComponent as ChatThreadIconNonActive } from './images/ChatThreadIconNonActive.svg';
export { ReactComponent as ChatPinIcon } from './images/chatPin.svg';
export { ReactComponent as PinnedChatIcon } from './images/PinnedChatIcon.svg';
export { ReactComponent as PinnedChatIconActive } from './images/PinnedChatIconActive.svg';
export { ReactComponent as ChatsIcon } from './images/ChatsIcon.svg';
export { ReactComponent as MessagesIcon } from './images/MessagesIcon.svg';
export { ReactComponent as TemplatesIcon } from './images/TemplatesIcon.svg';
export { ReactComponent as ChatThreadIcon } from './images/ChatThreadIcon.svg';
export { ReactComponent as WhatsappIcon } from './images/WhatsappIcon.svg';
export { ReactComponent as PrintIcon } from './images/PrintIcon.svg';
export { ReactComponent as BarcodeTemplate1 } from './images/BarcodeTemplate1.svg';
export { ReactComponent as BarcodeTemplate2 } from './images/BarcodeTemplate2.svg';
export { ReactComponent as BarcodeTemplate3 } from './images/BarcodeTemplate3.svg';
export { ReactComponent as Printer } from './images/Printer.svg';
export { ReactComponent as Tick1 } from './images/Tick1.svg';
export { ReactComponent as Tick2 } from './images/Tick2.svg';
export { ReactComponent as ScanLabelIcon } from './images/ScanLabelIcon.svg';
export { ReactComponent as EpicorIcon } from './images/epicor.svg';
export { ReactComponent as EpicorWhiteIcon } from './images/epicorWhite.svg';
export { ReactComponent as PenNib } from './images/PenNib.svg';
export { ReactComponent as TorqueSmsIcon } from './images/TorqueSms.svg';
export { ReactComponent as Mitchell1Logo } from './images/Mitchell1Logo.svg';
export { ReactComponent as PowerdByMitchel } from './images/PowerdByMitchel.svg';
export { ReactComponent as CSV } from './images/CSV.svg';
export { ReactComponent as DOC } from './images/DOC.svg';
export { ReactComponent as GIF } from './images/GIF.svg';
export { ReactComponent as JPG } from './images/JPG.svg';
export { ReactComponent as MP3 } from './images/MP3.svg';
export { ReactComponent as MP4 } from './images/MP4.svg';
export { ReactComponent as PDF } from './images/PDF.svg';
export { ReactComponent as PNG } from './images/PNG.svg';
export { ReactComponent as PPT } from './images/PPT.svg';
export { ReactComponent as TIFF } from './images/TIFF.svg';
export { ReactComponent as TXT } from './images/TXT.svg';
export { ReactComponent as XLS } from './images/XLS.svg';
export { ReactComponent as List } from './images/list.svg';
export { ReactComponent as DollarSign } from './images/DollarSign.svg';
export { ReactComponent as Eye } from './images/Eye.svg';
export { ReactComponent as RoTags } from './images/RoTags.svg';
export { ReactComponent as Closed } from './images/Closed.svg';
export { ReactComponent as Deleted } from './images/Deleted.svg';
export { ReactComponent as PhoneIcon } from './images/PhoneIcon.svg';
export { ReactComponent as Jobs } from './images/Jobs.svg';
export { ReactComponent as InProgressIcon } from './images/InProgressIcon.svg';
export { ReactComponent as DeclinedIcon } from './images/DeclinedIcon.svg';
export { ReactComponent as AwaitingAuthorizationIcon } from './images/AwaitingAuthorizationIcon.svg';
export { ReactComponent as AwaitingPartsIcon } from './images/AwaitingPartsIcon.svg';
export { ReactComponent as ReadyIcon } from './images/ReadyIcon.svg';
export { ReactComponent as EstimateIcon } from './images/EstimateIcon.svg';
export { ReactComponent as InspectionIcon } from './images/InspectionIcon.svg';
export { ReactComponent as OnHoldIcon } from './images/OnHoldIcon.svg';
export { ReactComponent as OnHold } from './images/OnHold.svg';
export { ReactComponent as WorkNotStartedIcon } from './images/WorkNotStartedIcon.svg';
export { ReactComponent as WrenchIcon } from './images/WrenchIcon.svg';
export { ReactComponent as Card } from './images/Card.svg';
export { ReactComponent as Cash } from './images/Cash.svg';
export { ReactComponent as Cheque } from './images/Cheque.svg';
export { ReactComponent as WhiteLabelTorquePay } from './images/WhiteLabelTorquePay.svg';
export { ReactComponent as Sparkle } from './images/Sparkle.svg';
export { ReactComponent as West22 } from './images/22West.svg';
export { ReactComponent as RadiatorAc1800 } from './images/1800RadiatorAc.svg';
export { ReactComponent as AJay } from './images/A&Jay.svg';
export { ReactComponent as AdvanceAutoParts } from './images/AdvanceAutoParts.svg';
export { ReactComponent as AutoZone } from './images/AutoZone.svg';
export { ReactComponent as BumperToBumper } from './images/BumperToBumper.svg';
export { ReactComponent as CarQuest } from './images/CarQuest.svg';
export { ReactComponent as MotorPartsDistribution } from './images/MotorPartsDistribution.svg';
export { ReactComponent as AutoParts } from './images/AutoParts.svg';
export { ReactComponent as OreillyAutoParts } from './images/OreillyAutoParts.svg';
export { ReactComponent as PartsMan } from './images/PartsMan.svg';
export { ReactComponent as PepBoys } from './images/PepBoys.svg';
export { ReactComponent as WorldPac } from './images/WorldPac.svg';
export { ReactComponent as NoJobImage } from './images/NoJobImage.svg';
// export { ReactComponent as PlusIcon } from './images/PlusIcon.svg';
export { ReactComponent as Wrench } from './images/Wrench.svg';
export { ReactComponent as LaborGuides } from './images/LaborGuides.svg';
export { ReactComponent as Confetti } from './images/Confetti.svg';
export { ReactComponent as MailIcon } from './images/MailIcon.svg';
export { ReactComponent as SmsIcon } from './images/SmsIcon.svg';
export { ReactComponent as NoJobsSelected } from './images/NoJobsSelected.svg';
export { ReactComponent as PlusExpandAccordion } from './images/PlusExpandAccordion.svg';
export { ReactComponent as MinusDownscaleAccordion } from './images/MinusDownscaleAccordion.svg';
export { ReactComponent as NoImageDefault } from './images/noImageDefault.svg';
export { ReactComponent as CheckedTick } from './images/CheckedTick.svg';
export { ReactComponent as NoLaborSelected } from './images/NoLaborSelected.svg';
export { ReactComponent as NoPartsSelected } from './images/NoPartsSelected.svg';
export { ReactComponent as CheckedRound } from './images/CheckedRound.svg';
export { ReactComponent as UncheckedRound } from './images/UncheckedRound.svg';
export { ReactComponent as NoServiceIntervalsSelected } from './images/NoServiceIntervalsSelected.svg';
export { ReactComponent as ClockCountdown } from './images/ClockCountdown.svg';
export { ReactComponent as OpenBook } from './images/OpenBook.svg';
export { ReactComponent as ServiceInterval } from './images/ServiceInterval.svg';
export { ReactComponent as Canned } from './images/Canned.svg';
export { ReactComponent as Job } from './images/Job.svg';
// export { ReactComponent as PlusIcon } from './images/PlusIcon.svg';
export { ReactComponent as Fee } from './images/Fee.svg';
export { ReactComponent as Telesign } from './images/Telesign.svg';
export { ReactComponent as CardPresent } from './images/CardPresent.svg';
export { ReactComponent as EmailIconNew } from './images/emailIconNew.svg';
export { ReactComponent as SmsIconNew } from './images/smsIconNew.svg';
export { ReactComponent as ReportIconNew } from './images/reportIconNew.svg';
export { ReactComponent as DownloadFile } from './images/DownloadFile.svg';
export { ReactComponent as AttachmentFile } from './images/AttachmentFile.svg';
export { ReactComponent as SendPaymentRequest } from './images/SendPaymentRequest.svg';
export { ReactComponent as NewAmexCard } from './images/NewAmexCard.svg';
export { ReactComponent as NewDiscoverCard } from './images/NewDiscoverCard.svg';
export { ReactComponent as NewMasterCard } from './images/NewMasterCard.svg';
export { ReactComponent as NewVisaCard } from './images/NewVisaCard.svg';
export { ReactComponent as CrossDollar } from './images/CrossDollar.svg';
export { ReactComponent as TrashNew } from './images/TrashNew.svg';
export { ReactComponent as Pen } from './images/Pen.svg';
export { ReactComponent as Duplicate } from './images/Duplicate.svg';
export { ReactComponent as CannedJob } from './images/CannedJob.svg';
export { ReactComponent as AddOrangeFilled } from './images/AddOrangeFilled.svg';
export { ReactComponent as UserPlus } from './images/UserPlus.svg';
export { ReactComponent as Ranch } from './images/Ranch.svg';
export { ReactComponent as OrderNowIcon } from './images/OrderNowIcon.svg';
export { ReactComponent as PartsIcon } from './images/PartsIcon.svg';
export { ReactComponent as MiscIcon } from './images/Miscellaneous.svg';
export { ReactComponent as WheelsIcon } from './images/WheelsIcon.svg';
export { ReactComponent as TiresIcon } from './images/TiresIcon.svg';
export { ReactComponent as OilIcon } from './images/OilIcon.svg';
export { ReactComponent as EditIcon } from './images/EditIcon.svg';
export { ReactComponent as DeleteBin } from './images/DeleteBin.svg';
export { ReactComponent as NotePencilIcon } from './images/NotePencilIcon.svg';
export { ReactComponent as TimerIcon } from './images/TimerIcon.svg';
export { ReactComponent as ARLogo } from './images/ARLogo.svg';
export { ReactComponent as EditIconReports } from './images/EditIconReports.svg';
export { ReactComponent as CashNew } from './images/CashNew.svg';
export { ReactComponent as CheckNew } from './images/CheckNew.svg';
export { ReactComponent as CardNew } from './images/CardNew.svg';
export { ReactComponent as NullFile } from './images/NullFile.svg';
export { ReactComponent as Warning } from './images/Warning.svg';
export { ReactComponent as HandExtended } from './images/HandExtended.svg';
export { ReactComponent as PaymentIcon } from './images/PaymentIcon.svg';
export { ReactComponent as Star } from './images/Star.svg';
